import { checkAPIResponse } from "../../../Utils/APIResponseUtils";
import apiService from "../../../Services/APIService";

export const updateCompanyProfile = async (changeType, agencyData) => {
  try {
    const payload = {
      changeType: changeType,
      companyName: agencyData.companyName || '',
      city: agencyData.city || '',
      stateID: agencyData.stateID || 0,
      state: agencyData.stateName || agencyData.state || '',
      countryID: agencyData.countryID || 0,
      country: agencyData.countryName || agencyData.country || '',
      email: agencyData.email || '',
      taxID: agencyData.taxID || '',
      logo: agencyData.logo || '',
      pocUserID: agencyData.pocUserID || 0,
      pin: agencyData.pin || 0,

      // webstore specific fields
      bizTypes: agencyData.businessTypes || '',
      sellToDesc: agencyData.whatDoYouSell || '',
      segmentID: agencyData.segmentID || 0,
      industryID: agencyData.industryID || 0,
      tagline: agencyData.businessTagline || '',
      description: agencyData.description || '',
      locLink: agencyData.googleMapsLink || '',
      goal: agencyData.goal || '',
      values: agencyData.values || '[]',
    };
    const result = await apiService.sendChange(6, "setProfile", payload);
    return result;
  } catch (error) {
    console.error('Error updating company profile:', error);
    throw error;
  }
};

export const catalogProductAPI = async (changeType, productData = {}, agencyData = {}) => {
  try {
    let valuesObj = [];

    switch (changeType) {
      case 'ADDPRD':
        valuesObj = [{
          PNm: productData.name?.trim() || productData.PNm?.trim() || '',
          PImg: productData.imageUrl || productData.PImg || '',
          PTxt: productData.description?.trim() || productData.PTxt?.trim() || '',
          STID: Number(productData.typeID || productData.STID) || 1,
          STNm: productData.typeName || productData.STNm || (productData.typeID === 2 ? 'Service' : 'Product'),
        }];
        break;

      case 'UPDPRD':
        valuesObj = [{
          PID: Number(productData.pid ?? productData.PID),
          PNm: productData.name?.trim() || productData.PNm?.trim() || '',
          PImg: productData.imageUrl || productData.PImg || '',
          PTxt: productData.description?.trim() || productData.PTxt?.trim() || '',
          STID: Number(productData.typeID || productData.STID) || 1,
          STNm: productData.typeName || productData.STNm || (productData.typeID === 2 ? 'Service' : 'Product'),
        }];
        break;

      case 'DLTPRD':
        valuesObj = [{
          PID: Number(typeof productData === 'object' ? (productData.pid ?? productData.PID) : productData),
        }];
        break;

      default:
        throw new Error(`Unsupported catalog changeType: ${changeType}`);
    }

    const payload = {
      changeType,
      companyName: agencyData.AgencyName || agencyData.companyName || '',
      city: agencyData.City || agencyData.city || '',
      stateID: agencyData.StateID || agencyData.stateID || 0,
      state: agencyData.State || agencyData.state || '',
      countryID: agencyData.CountryID || agencyData.countryID || 1,
      country: agencyData.Country || agencyData.country || 'India',
      email: agencyData.Email || agencyData.email || '',
      taxID: agencyData.TaxID || agencyData.taxID || '',
      logo: agencyData.Logo || agencyData.logo || '',
      pocUserID: agencyData.POCUserID || agencyData.pocUserID || 0,
      pin: 0,
      bizTypes: '',
      sellToDesc: '',
      segmentID: 0,
      industryID: 0,
      tagline: '',
      description: '',
      locLink: '',
      goal: '',
      values: JSON.stringify(valuesObj),
    };

    const result = await apiService.sendChange(6, "setProfile", payload);
    checkAPIResponse(result);
    return result;
  } catch (error) {
    console.error(`Error in catalogProductAPI (${changeType}):`, error);
    throw error;
  }
};

export const sendRemindPINAPI = async (mobile, cc) => {
  try {
    let verifyUserObj = {
      mobile,
      cc,
      changeType: "RMD"
    };
    const result = await apiService.accessGetData(4, 'sendUsrOTP', verifyUserObj);
    return result;
  } catch (error) {
    console.error('Error sending PIN:', error);
    throw error;
  }
};